import { render, staticRenderFns } from "./MyConnections.vue?vue&type=template&id=0397c83b"
import script from "./MyConnections.vue?vue&type=script&lang=ts"
export * from "./MyConnections.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports